const adapters = {
  'studio-editor-v2/schema-v1': (bundle) => bundle,
  'studio-editor-v2/schema-v2': (bundle) => bundle,
}

export function adaptTemplateBundle(bundle) {
  const dialect = bundle?.manifest?.schemaDialect || bundle?.schema?.dialect
  const adapter = adapters[dialect]
  if (!adapter) {
    throw new Error(`This editor does not support the template schema dialect: ${dialect || 'unknown'}.`)
  }

  return adapter(bundle)
}
